import React, { useEffect } from 'react'

function OtpTimer({ otpCounter, counter }) {

  function convertTime(sec) {
    var hours = Math.floor(sec / 3600)
    hours >= 1 ? (sec = sec - hours * 3600) : (hours = '00')
    var min = Math.floor(sec / 60)
    min >= 1 ? (sec = sec - min * 60) : (min = '00')
    sec < 1 ? (sec = '00') : void 0

    min.toString().length === 1 ? (min = '0' + min) : void 0
    sec.toString().length === 1 ? (sec = '0' + sec) : void 0

    return min + ':' + sec
  }
  useEffect(() => {
    if (counter > 0) {
      setTimeout(() => {
        otpCounter(counter - 1)
      }, 1000)
    } else {
      otpCounter(0)
    }
  }, [counter])

  return counter === 0 ? (
    <div className="ml-3 otp-text"> You can resend the OTP now.</div>
  ) : (
    <div className="ml-3 otp-text">
      {' '}
      OTP can be resend after {convertTime(counter)}  Minutes. OTP will be valid for 10 Minutes.
    </div>
  )

}

export default OtpTimer
